<div class="row">
  <div class="col-12">
    <nb-card>
      <nb-card-header>
        <div class="d-flex align-items-center">
          <i class="fal fa-bell ms-2"></i>
          ارسال اعلان عمومی
        </div>
      </nb-card-header>
      <nb-card-body>
        <div class="row">
          <div class="col-6">
            <input
              [status]="error['title'] === undefined ? 'basic' : 'danger'"
              class="w-100"
              placeholder="تیتر پیام"
              [(ngModel)]="title"
              nbInput
            />
            <app-validation-error [errors]="error" name="title"></app-validation-error>
          </div>
          <div class="col-12 my-3">
            <textarea
              [status]="error['message'] === undefined ? 'basic' : 'danger'"
              [(ngModel)]="message"
              rows="5"
              nbInput
              fullWidth
              placeholder="متن پیام"
            ></textarea>
            <app-validation-error [errors]="error" name="message"></app-validation-error>
          </div>
          <div class="col-12">
            <button
              [nbSpinner]="loading"
              [disabled]="loading"
              (click)="onSubmit()"
              class="px-5"
              nbButton
              status="primary"
            >
              ارسال
            </button>
            <app-validation-error [errors]="error" name="userId"></app-validation-error>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
